import { render } from "./ORG_CREATED.vue?vue&type=template&id=7444ea81"
import script from "./ORG_CREATED.vue?vue&type=script&lang=js"
export * from "./ORG_CREATED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__